export default __webpack_public_path__ + "static/media/art-pro-blk-banner-2.56bbb9be.jpg";